import IconButton from 'lib/components/buttons/icon-button'
import Button from 'components/core/button'
import { X, Plus } from 'lucide-react'
import { cn } from 'lib/util/cn'
import { useBillingPlans } from './billing-plans-context'
import { displayPriceDifference, professionalPlan } from 'lib/util/billing'

export default function BillingModalProfessionalServices() {
  const { currency, currentSubscriptions, period, plans, selectedPlans, updateSelectedPlans } = useBillingPlans()
  const creativePlan = selectedPlans?.creativePlan
  const professionalServicesPlan = professionalPlan(plans, creativePlan?.dailyTime)
  const disabled = !creativePlan
  const hasProfessionalPlan = !!selectedPlans?.professionalPlan
  const getPriceDifference = () => {
    const currentPlanPrice = +currentSubscriptions?.professionalSubscription?.picklePlan?.price || 0
    const selectedPlanPrice = +professionalServicesPlan?.price || 0
    if (!currentPlanPrice && !selectedPlans?.professionalPlan) {
      return selectedPlanPrice
    }
    return selectedPlanPrice - currentPlanPrice
  }

  return (
    <div className={cn(disabled && 'tw-pointer-events-none tw-opacity-50')}>
      <div
        className={cn(
          'tw-flex tw-h-[4.5rem] tw-justify-between tw-rounded tw-border tw-border-solid tw-p-4',
          hasProfessionalPlan ? 'tw-border-cornflower-300 tw-bg-neutral-50' : 'tw-border-neutral-200',
        )}
      >
        <div>
          <div className="tw-font-semibold tw-text-peppercorn-900">Professional services</div>
          <div>Description placeholder</div>
        </div>
        <div className="tw-flex tw-items-center tw-gap-2">
          {!disabled && (
            <div className="tw-w-24 tw-text-right">
              <div className="tw-font-semibold tw-text-peppercorn-900">
                {displayPriceDifference(getPriceDifference(), currency)}
              </div>
              <div>billed {period}</div>
            </div>
          )}
          {hasProfessionalPlan ? (
            <IconButton color="secondary" onClick={() => updateSelectedPlans(null, 'professional')}>
              <X />
            </IconButton>
          ) : (
            <Button
              color="neutral"
              className="tw-ml-2"
              onClick={() => updateSelectedPlans(professionalServicesPlan, 'professional')}
              disabled={disabled}
            >
              <Plus />
              Add
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
